import { Fragment, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectAccessToken } from '../../../slices/staffSlice';
import { fetchRequests } from '../../../Requests/getRequests';
import { authStaff } from '../../../utils/constants';
import { show } from '../../../slices/toastSlice';
import { Dialog, Transition } from '@headlessui/react';
import { HugeiconsIcon } from '@hugeicons/react';
import { Alert02Icon } from '@hugeicons/core-free-icons';
import { Button } from '../../../components';

function Toggle({ isOpen, onClose, partner, onToggled }) {

    const accessToken = useSelector(selectAccessToken);
    const dispatch = useDispatch();
    const [processing, setProcessing] = useState(false);

    const isActive = partner?.status === 'active';

    const handleToggle = async () => {
        setProcessing(true);
        const headers = authStaff(accessToken);
        const res = await fetchRequests('/loans/staff/partner-apis/toggle', 'PUT', headers, {}, {
            _id: partner._id
        });

        if (res?.err) {
            dispatch(show({ type: 'error', state: true, message: res.err }));
        } else {
            dispatch(show({ type: 'success', state: true, message: res?.message || 'Partner status updated' }));
            onToggled();
        }
        setProcessing(false);
    };

    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-50" onClose={onClose}>
                <Transition.Child as={Fragment} enter="ease-out duration-200" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-150" leaveFrom="opacity-100" leaveTo="opacity-0">
                    <div className="fixed inset-0 bg-black/30" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4">
                        <Transition.Child as={Fragment} enter="ease-out duration-200" enterFrom="opacity-0 scale-95" enterTo="opacity-100 scale-100" leave="ease-in duration-150" leaveFrom="opacity-100 scale-100" leaveTo="opacity-0 scale-95">
                            <Dialog.Panel className="w-full max-w-sm bg-white dark:bg-gray-800 rounded-2xl shadow-xl overflow-hidden">
                                <div className="px-6 py-5 space-y-4">
                                    <div className="flex items-center gap-3">
                                        <div className={`w-10 h-10 rounded-xl flex items-center justify-center shrink-0 ${isActive ? 'bg-red-50 dark:bg-red-500/10' : 'bg-emerald-50 dark:bg-emerald-500/10'}`}>
                                            <HugeiconsIcon icon={Alert02Icon} size={20} className={isActive ? 'text-red-500' : 'text-emerald-500'} />
                                        </div>
                                        <div>
                                            <h3 className="text-sm font-semibold text-gray-900 dark:text-gray-50">
                                                {isActive ? 'Disable' : 'Enable'} Partner API
                                            </h3>
                                            <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                                                {partner?.name} ({partner?.code})
                                            </p>
                                        </div>
                                    </div>

                                    <p className="text-sm text-gray-600 dark:text-gray-300">
                                        {isActive
                                            ? 'This will immediately block all API requests from this partner. Are you sure?'
                                            : 'This will allow this partner to make API requests again. Continue?'
                                        }
                                    </p>

                                    <div className="flex items-center gap-3">
                                        <Button
                                            btnText={isActive ? 'Disable' : 'Enable'}
                                            btnClasses={`inline-flex items-center px-4 py-2.5 text-sm font-medium text-white rounded-lg transition-colors ${isActive ? 'bg-red-600 hover:bg-red-700' : 'bg-emerald-600 hover:bg-emerald-700'}`}
                                            btnFunction={handleToggle}
                                            btnType="button"
                                            processing={processing}
                                        />
                                        <button type="button" onClick={onClose} className="px-4 py-2.5 text-sm font-medium text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200 transition-colors">
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    );
}

export default Toggle;
